import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";
import { translate } from "react-i18next";
import { Button, Form, FormGroup, Alert } from "reactstrap";
import { statusEnum } from "../actions/constant";
import { InputText, Loading, Validations } from "../components";
import resetPasswordActions from "../actions/resetPasswordActions";

import "./styles/homePage.css";
import "./styles/authModern.css";
import i18n from "../i18n";
import i18next, { t } from "i18next";

// password validation
const required = Validations.required;
const min8 = Validations.min8;
const max15 = Validations.max15;
const minOneUppercase = Validations.min_one_uppercase;
const minOneNumber = Validations.min_one_number;
const minOneSpecial = Validations.min_one_special;

const LANG_MAP = {
  '1200000000001000022': 'en-US',
  '1200000000001000015': 'zh-CN',
  '1200000000001000016': 'zh-TW',
};
const mapLangIdToI18n = (id) => LANG_MAP[id] || null;

let ResetPasswordForm = (props) => {
  const { t } = props;
  return (
    <Form onSubmit={props.handleSubmit}>
      <FormGroup>
        <Field
          component={InputText}
          type="password"
          name="password"
          placeholder={t("reset.NEW_PASSWORD")}
          validate={[required, min8, max15]}
          autocomplete="off"
          style={{ paddingRight: 36 }}
        />
        <div
          style={{
            position: "absolute",
            top: "5px",
            right: "11px",
            cursor: "pointer",
          }}
          onClick={props.showResPass}
        >
          <i
            className={
              props.showResetPassword ? "far fa-eye" : "far fa-eye-slash"
            }
            style={{
              color: "#077bff",
            }}
          />
        </div>
      </FormGroup>
      <FormGroup>
        <Field
          component={InputText}
          type="password"
          name="passwordConfirm"
          autocomplete="off"
          placeholder={t("reset.NEW_PASSWORD_CONFIRM")}
          validate={[
            Validations.required,
            min8,
            max15,
            minOneUppercase,
            minOneNumber,
            minOneSpecial,
          ]}
          style={{ paddingRight: 36 }}
        />
        <div
          style={{
            position: "absolute",
            top: "5px",
            right: "11px",
            cursor: "pointer",
          }}
          onClick={props.showResPassConfirm}
        >
          <i
            className={
              props.showResetPasswordConfirm ? "far fa-eye" : "far fa-eye-slash"
            }
            style={{
              color: "#077bff",
            }}
          />
        </div>
      </FormGroup>
      <div className="submit2 row justify-content-between">
        <div className="col">
          <Button
            className="button-submit"
            color="primary"
            onClick={props.onCancel}
          >
            {t("general.CANCEL")}
          </Button>
        </div>
        <div className="col">
          <Button className="button-submit" color="primary">
            {t("general.SUBMIT")}
          </Button>
        </div>
      </div>
    </Form>
  );
};

ResetPasswordForm = reduxForm({
  form: "formResetPassword",
})(ResetPasswordForm);

class ResetPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showResetPassword: false,
      showResetPasswordConfirm: false,
      langReady: false,
    };
  }

  async componentDidMount() {
    // last path segment is the language ID
    const parts = ((this.props.location && this.props.location.pathname) || window.location.pathname)
      .split("/")
      .filter(Boolean);
    const langId = parts[parts.length - 1];
    const langCode = mapLangIdToI18n(langId);

    if (langCode && i18n.language !== langCode) {
      try {
        // 1) switch language
        await i18n.changeLanguage(langCode);

        try { localStorage.setItem("i18nextLng", langCode); } catch (e) {}
      } catch (e) {/* no-op */}
    }
    this.setState({ langReady: true });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.status === statusEnum.SUCCESS) {
      setTimeout(() => this.props.history.push("/"), 2000);
    }
  }

  componentWillMount() {
    this.props.setDefaultState();
  }

  handleSubmit(values) {
    if (values.password !== values.passwordConfirm) {
      this.props.submitValidation(
        this.props.t("reset.PASSWORD_CONFIRM_NOT_MATCH")
      );
    } else {
      this.props.resetPasswordSubmit(values);
    }
    setTimeout(() => {
      window.location.href = "/";
    }, 2000);
  }

  cancelClicked() {
    this.props.history.push("/");
  }

  showResPass() {
    this.setState({
      showResetPassword: !this.state.showResetPassword,
    });
  }
  showResPassConfirm() {
    this.setState({
      showResetPasswordConfirm: !this.state.showResetPasswordConfirm,
    });
  }

  render() {
    const { isLoading, status, actionResponse, t } = this.props;
    if (!this.state.langReady) {
      return <Loading isLoading={true} />;  // ensures first paint is correct-language
    }

    return (
      <div className="auth-modern">
        <Loading isLoading={isLoading} />
        <div className="row justify-content-center">
          <div className="login-box col-lg-4 col-md-6">
            <p className="forgot-title">{t("reset.NEW_PASSWORD")}</p>
            <ResetPasswordForm
              key={i18n.language} // ← force re-mount on language change
              onSubmit={this.handleSubmit.bind(this)}
              onCancel={this.cancelClicked.bind(this)}
              t={t}
              showResetPassword={this.state.showResetPassword}
              showResetPasswordConfirm={this.state.showResetPasswordConfirm}
              showResPass={this.showResPass.bind(this)}
              showResPassConfirm={this.showResPassConfirm.bind(this)}
            />
            {status === statusEnum.SUCCESS && (
              <Alert color="success">
                {t("general.SUBMIT_SUCCESS_MESSAGE")}
              </Alert>
            )}
            {status === statusEnum.ERROR && (
              <Alert color="danger">{actionResponse.message}</Alert>
            )}
          </div>
        </div>
      </div>
    );
  }
}

ResetPassword = translate("translations")(ResetPassword);

const mapStateToProps = (state) => ({ ...state.resetPassword });

const matchDispatchToProps = (dispatch) =>
  bindActionCreators({ ...resetPasswordActions }, dispatch);

export default connect(mapStateToProps, matchDispatchToProps)(ResetPassword);



// WEBPACK FOOTER //
// ./src/pages/ResetPassword.js